import { Retailer_Network_User_Role } from '@occc/graphql';

export const userRolesDropdownOptions = [
  {
    label: 'Network Admin',
    role: Retailer_Network_User_Role.RetailerNetworkAdmin,
  },
  {
    label: 'Network User',
    role: Retailer_Network_User_Role.RetailerNetworkUser,
  },
];
